require ('./userNotificationContentList.scss');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');
const className = require('classnames');
const PropTypes = require('prop-types');

// @ utilities
const { hash } = require('utilities/hash');
const { getNotificationActions } = require('utilities/notificationHelper');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const UserNotificationsContent = require('components/userNotifications/userNotificationsContent/userNotificationsContent');

const {
    NOTIFICATIONS_STATUS_PENDING,
    NOTIFICATIONS_STATUS_DELIVERED,
    NOTIFICATIONS_STATUS_ERROR,
    NOTIFICATION_DEEP_LINK_HB_CHORE
} = require('constants/index');

class UserNotificationsContentList extends React.Component {

    constructor(props) {
        super(props);

        this.getCustomMessages = this.getCustomMessages.bind(this);
        this.getNotificationMessage = this.getNotificationMessage.bind(this);
        this.isMessageNotADisclaimer = this.isMessageNotADisclaimer.bind(this);
        this.hasPushNotificationType = this.hasPushNotificationType.bind(this);
        this.isUnreadNotification = this.isUnreadNotification.bind(this);
        this.handleActionClick = this.handleActionClick.bind(this);
        this.cardSuccessCallback = this.cardSuccessCallback.bind(this);
        this.errorCallback = this.errorCallback.bind(this);
    }

    getCustomMessages(immNotification) {
        let customMessage = {};
        const message = immNotification.get('message').toUpperCase();
        const iban = immNotification.get('iban');

        switch(immNotification.get('messageType')) {
            case 'NOTIFICATION':
                customMessage = this.getNotificationMessage(message, iban);
                break;
            case 'OTHER':
                customMessage = {
                    linkText : 'userNotifications-customLinkPending',
                    message : immNotification.get('message')
                }
                break;
            default:
                customMessage = {
                    linkText : null,
                    message : null
                }
        }
        return customMessage;
    }

    getNotificationMessage(message, iban) {
        let customMessages = {};

        switch (message) {
            case 'PENDING':
                customMessages.linkText = 'userNotifications-customLinkPending';
                customMessages.message = formatText('userNotifications-customMessagePending');
                break;
            case 'READY':
                customMessages.linkText = 'userNotifications-customLinkReady';
                customMessages.message = formatText('userNotifications-customMessageReady');
                break;
            case 'ACTIVE':
                customMessages.linkText = null;
                customMessages.message = formatText('userNotifications-customMessageActive', [iban]);
                break;
            default:
                customMessages.linkText = null;
                customMessages.message = null;
                break;
        }

        return customMessages;
    }

    isMessageNotADisclaimer(messageType) {
        return trim(messageType).toUpperCase() !== 'DISCLAIMER';
    }

    hasPushNotificationType(messageType) {
        return trim(messageType).toUpperCase() === 'PUSH';
    }

    hasOtherNotificationType(messageType) {
        return trim(messageType).toUpperCase() === 'OTHER';
    }

    isUnreadNotification(status) {
        return (status === NOTIFICATIONS_STATUS_PENDING || status === NOTIFICATIONS_STATUS_DELIVERED || status === NOTIFICATIONS_STATUS_ERROR);
    }

    handleActionClick(event, action) {
        event && event.stopPropagation();
        const {
            history,
            onHandleNavigation
        } = this.props;
        if (action.action) {
            const data = {
                isExpanded: true,
                path: action.path,
                successCallback: this.cardSuccessCallback,
                errorCallback: this.errorCallback
            }
            action.action(action.referenceId, data);
        } else {
            history.push(`/myprofile${action.path}`);
            onHandleNavigation && onHandleNavigation(false, action.hiringFlowType);
        }
    }

    cardSuccessCallback(url, response){
        const {
            history,
            onHandleNavigation
        } = this.props;
        let hashedPan = '';

        const last4DigitPan = response.last4DigitPan || response.last4DigitOfPan;
        hashedPan = this.generateHashedPan(last4DigitPan);
        if (hashedPan) {
            history.push(`/myprofile/cards/${hashedPan}${url}`);
        }
        onHandleNavigation && onHandleNavigation(false);
    }

    errorCallback(){
        this.props.onHandleNavigation && this.props.onHandleNavigation(true);
    }

    generateHashedPan(last4DigitPan){
        const { immCards } = this.props;
        let hashedPan = '';

        immCards.get('byId').every((immCard) => {
            const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
            const last4DigitPanCard = fullPanNumber.substr(fullPanNumber.length - 4);
            const isPanNumberMatched = last4DigitPan === last4DigitPanCard;
            if (isPanNumberMatched) {
                hashedPan = hash(fullPanNumber);
            }
            return !isPanNumberMatched;
        });
        return hashedPan;
    }

    buildUserNotificationsContent() {
        const {
            classNames,
            flagBasedFeatures,
            getChoreDetail,
            getMoneyRequestDetails,
            immUserNotifications,
            moneySavingsRequestDetails,
        } = this.props;
        const immNotificationsList = immUserNotifications.get('notifications');

        const validNotificationsToDisplay = immNotificationsList.filter((immNotification) => {
            const notificationType = immNotification.get('messageType');
            return this.isMessageNotADisclaimer(notificationType);
        });

        let contentList = validNotificationsToDisplay.map( (immNotification, index) => {
            const key = `user-notification-${index}`;
            const customMessages = this.getCustomMessages(immNotification);
            const message = customMessages.message || immNotification.get('message');
            const linkText = customMessages.linkText || null;
            let isNotificationClickable = false;
            let actions = [], messageLinkAction = {};
            if ((this.hasPushNotificationType(immNotification.get('messageType')) || this.hasOtherNotificationType(immNotification.get('messageType')))
                && immNotification.get('actionRequired')) {
                if (immNotification.get('deeplink') === NOTIFICATION_DEEP_LINK_HB_CHORE){
                    isNotificationClickable = true;
                }
                const notificationActions = getNotificationActions(immNotification.get('deeplink'), flagBasedFeatures, getChoreDetail, getMoneyRequestDetails, moneySavingsRequestDetails);
                messageLinkAction = notificationActions.messageLinkAction;
                actions = notificationActions.actions;
            }
            const isUnreadNotification = this.isUnreadNotification(immNotification.get('deliveryStatus'));
            const customClass = className('user-notifications-content-list__elements', {
                'user-notifications-content-list__elements--unread-notification': isUnreadNotification
            });

            return (
                <li className={customClass} key={key}>
                    <UserNotificationsContent
                        date={immNotification.get('createdOn')}
                        link={immNotification.get('url')}
                        linkText={linkText}
                        message={message}
                        referenceId={immNotification.get('referenceId')}
                        isNotificationClickable={isNotificationClickable}
                        messageLinkAction={messageLinkAction}
                        onHandleActionClick={this.handleActionClick}
                        actions={actions}
                        className={classNames}
                    />
                </li>
            );
        });
        return contentList;
    }

    render() {
        const { immUserNotifications } = this.props;
        const immNotificationsList = immUserNotifications.get('notifications');
        let dataToRender;

        if (immNotificationsList.size) {
           dataToRender = this.buildUserNotificationsContent();
        } else {
            dataToRender = (
                <div className="text-center user-notifications-content-list__empty">
                    <div className="user-notifications-content-list__empty-header">
                        <FormattedText value="userNotifications-emptyTitle" />
                    </div>
                    <FormattedText value="userNotifications-emptyContent" />
                </div>
            );
        }

        return dataToRender;
    }
}

UserNotificationsContentList.propTypes = {
    classNames: PropTypes.string,
    flagBasedFeatures: PropTypes.object,
    getChoreDetail: PropTypes.func,
    getMoneyRequestDetails: PropTypes.func,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immUserNotifications: PropTypes.object.isRequired,
    moneySavingsRequestDetails: PropTypes.func,
    openYoungCardChores: PropTypes.object.isRequired,
    onHandleNavigation: PropTypes.func
};

module.exports = withRouter(UserNotificationsContentList);

